import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { MOBILE_BREAKPOINT } from '../../Utils/responsive';
import NewProjectWeb from './web';
import NewProjectMob from './mob';
import { useAppSelector } from '../../store/hooks';
import { selectUserProfile, selectUserStatus } from '../../Module/User/Presentation/userSelectors';
import { canCreateNewProject } from '../../Utils/projectCreationGuard';
import { PATHS } from '../../routes/paths';

const NewProject = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);
  const userProfile = useAppSelector(selectUserProfile);
  const userStatus = useAppSelector(selectUserStatus);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (userStatus === 'loading' && !userProfile) {
    return null;
  }

  if (userProfile && !canCreateNewProject(userProfile)) {
    return <Navigate to={PATHS.MY_ACCOUNT} replace />;
  }

  return isMobile ? <NewProjectMob /> : <NewProjectWeb />;
};

export default NewProject;
